import NumberIo from './components/NumberIo';

export default NumberIo;
